import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

declare const TradingView: any;

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit, AfterViewInit {

  title = 'ابزار تحلیل تکنیکال';

  exchange: string = String(this.activateRoute.snapshot.paramMap.get('exchangeId'));
  coin: string = String(this.activateRoute.snapshot.paramMap.get('coinId'));
  toCoin: string = String(this.activateRoute.snapshot.paramMap.get('pairId'));

  light: boolean = false;


  constructor(
    private activateRoute: ActivatedRoute,
    private titleService: Title
  ) { }

  ngOnInit() {

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    new TradingView.widget(
      {
        "width": window.innerWidth,
        "height": window.innerHeight - 52.5,
        "symbol": this.exchange + ":" + this.coin + this.toCoin,
        "interval": "60",
        "timezone": "Asia/Tehran",
        "theme": "dark",
        "style": "1",
        "locale": "fa_IR",
        "toolbar_bg": "#f1f3f6",
        "enable_publishing": false,
        "hide_side_toolbar": false,
        "studies": [
          "RSI@tv-basicstudies"
        ],
        "container_id": "tradingview_06207"
      }
    );
  }

  ngAfterViewInit(){
    new TradingView.widget(
      {
        "width": window.innerWidth,
        "height": window.innerHeight - 52.5,
        "symbol": this.exchange + ":" + this.coin + this.toCoin,
        "interval": "60",
        "timezone": "Asia/Tehran",
        "theme": "dark",
        "style": "1",
        "locale": "fa_IR",
        "toolbar_bg": "#f1f3f6",
        "enable_publishing": false,
        "hide_side_toolbar": false,
        "studies": [
          "RSI@tv-basicstudies"
        ],
        "container_id": "tradingview_06207"
      }
    );
  }

  changeTheme() {
    this.light = this.light == false ? true : false;
    new TradingView.widget(
      {
        "width": window.innerWidth,
        "height": window.innerHeight - 50,
        "symbol": this.exchange + ":" + this.coin + this.toCoin,
        "interval": "60",
        "timezone": "Asia/Tehran",
        "theme": this.light == true ? 'light' : 'dark',
        "style": "1",
        "locale": "fa_IR",
        "toolbar_bg": "#f1f3f6",
        "enable_publishing": false,
        "hide_side_toolbar": false,
        "studies": [
          "RSI@tv-basicstudies"
        ],
        "container_id": "tradingview_06207"
      }
    );
  }


}
